<template>
	<div class="mini-app-wizard mt-4">
		<div class="top-section">
			<v-tabs-items v-model="localTab">
				<v-tab-item v-for="(item, index) in tabItems" :key="item.tab">
					<v-card flat>
						<component
							class="mini-app-step-container"
							:is="item.component"
							:ref="`item_ref_${index}`"
							v-bind="item.props"
							v-on:updateState="updateState"
							:state="state"
							:finalResult="finalResult"
						/>
					</v-card>
				</v-tab-item>
			</v-tabs-items>
		</div>
		<div class="bottom-section flex-space-between--center mt-2 py-3">
			<div class="text-error">{{ showErrorMessge ? errorMessge : '' }}</div>
			<div>
				<OutlinedButton class="mr-2" small @click="$emit('on-mini-app-cancel')" v-if="localTab === 0">Cancel</OutlinedButton>
				<OutlinedButton class="mr-2" small @click="localTab -= 1" v-if="localTab > 0">Back</OutlinedButton>
				<PrimaryButton v-if="localTab < tabItems.length - 1" small @click="next()" :disabled="!isStepComplete">Next</PrimaryButton>
				<PrimaryButton v-else-if="localTab === tabItems.length - 1" small @click="finish" :disabled="!isStepComplete">Finish</PrimaryButton>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'MiniAppWizard',
	props: {
		tabItems: { type: Array },
		state: { type: Object },
		finalResult: { type: Array },
	},
	watch: {
		state() {
			this.$nextTick(() => {
				this.calceIsStepComplete();
				this.setErrorMessge();
			});
		},
	},
	methods: {
		updateState(newState) {
			this.$emit('updateState', newState);
		},
		next() {
			this.setErrorMessge();
			if (!this.errorMessge) {
				this.showErrorMessge = false;
				this.localTab += 1;
			} else {
				this.showErrorMessge = true;
			}
		},
		finish() {
			this.$emit('on-mini-app-finished');
		},
		calceIsStepComplete() {
			this.isStepComplete = this.$refs[`item_ref_${this.localTab}`][0].isStepComplete;
		},
		setErrorMessge() {
			const tabConf = this.tabItems[this.localTab];
			const { validator, props } = tabConf;
			this.errorMessge = validator(this.state, props);
		},
		cancelClicked() {
			if (this.callbacks) {
				const { cancelClicked } = this.callbacks;
				if (cancelClicked) {
					cancelClicked();
				}
			}
		},
	},
	data() {
		return {
			localTab: 0,
			isStepComplete: false,
			showErrorMessge: false,
			errorMessge: '',
		};
	},
};
</script>

<style scoped lang="scss">
.mini-app-wizard {
	.mini-app-step-container {
		height: 400px;
	}

	.is-validation-failed {
		background: red;
	}
}
</style>
